import React, { useState, useEffect, useRef } from "react";
import styled, { keyframes } from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import useDisplay from "../../../hooks/useDisplay";
import PretendardText from "../../atoms/text/pretendardText";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import { fileUrl } from "../../../api/api";

const PopupModal = ({
  data,
  btnOnPress,
  btnConfirmPress,
  isScroll,
}) => {
  const swiperRef = useRef();
  const { isMobile, isTablet, isDesktop } = useDisplay();

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!isScroll) {
      document.body.style.cssText = `
      position: fixed; 
      top: -${window.scrollY}px;
      overflow-y: hidden;
      width: 99%;`;
      return () => {
        const scrollY = document.body.style.top;
        document.body.style.cssText = "";
        window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
      };
    }
  }, [isScroll]);

  return (
    <ModalWrapper $isMobile={isMobile}>
      <ModalContain $isMobile={isMobile}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              height: isMobile ? 288 : 388,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              position: "relative",
            }}
          >
            <Swiper
              modules={[Autoplay, Navigation]}
              onSwiper={(it) => {
                swiperRef.current = it;
              }}
              slidesPerView={1}
              centeredSlides={true}
              spaceBetween={0}
              loop={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              onSlideChange={(swiper) => {
                setActiveIndex(swiper.realIndex);
              }}
            >
              {isMobile
                ? data.moImageList && data.moImageList.length > 0
                  ? data.moImageList.map((item, index) => {
                      return (
                        <SwiperSlide key={index}>
                          <img
                            src={`${fileUrl}/${item.imageServerFileName}`}
                            style={{
                              width: "100%",
                              height: 288,
                              borderTopLeftRadius: 20,
                              borderTopRightRadius: 20,
                            }}
                            alt=""
                          />
                        </SwiperSlide>
                      );
                    })
                  : null
                : data.pcImageList && data.pcImageList.length > 0
                ? data.pcImageList.map((item, index) => {
                    return (
                      <SwiperSlide key={index}>
                        <img
                          src={`${fileUrl}/${item.imageServerFileName}`}
                          style={{
                            width: "100%",
                            height: 388,
                            borderTopLeftRadius: 20,
                            borderTopRightRadius: 20,
                          }}
                          alt=""
                        />
                      </SwiperSlide>
                    );
                  })
                : null}
            </Swiper>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                position: "absolute",
                bottom: 18,
                zIndex: 10,
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              {isMobile
                ? Array(data.moImageList?.length ?? 0)
                    .fill(0)
                    .map((item02, index02) => {
                      return (
                        <div
                          key={index02}
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: 99,
                            background:
                              index02 === activeIndex
                                ? "#FFFFFF"
                                : "rgba(255, 255, 255, 0.5)",
                            marginRight:
                              data.moImageList?.length === index02 + 1 ? 0 : 10,
                          }}
                        />
                      );
                    })
                : Array(data.pcImageList?.length ?? 0)
                    .fill(0)
                    .map((item02, index02) => {
                      return (
                        <div
                          key={index02}
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: 99,
                            background:
                              index02 === activeIndex
                                ? "#FFFFFF"
                                : "rgba(255, 255, 255, 0.5)",
                            marginRight:
                              data.pcImageList?.length === index02 + 1 ? 0 : 10,
                          }}
                        />
                      );
                    })}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <LSRgH2HeadLine
              onClick={() => {
                btnOnPress();
              }}
              style={{
                flex: 1,
                fontSize: isMobile ? 13 : 18,
                fontWeight: 400,
                textAlign: "center",
                cursor: "pointer",
                padding: isMobile ? "13px 0px 18.5px 0px" : "18px 0px 19px 0px",
                borderRight: "1px solid #F1F1F1",
              }}
            >
              오늘 하루 보지 않기
            </LSRgH2HeadLine>
            <LSRgH2HeadLine
              onClick={() => {
                btnConfirmPress();
              }}
              style={{
                flex: 1,
                fontSize: isMobile ? 13 : 18,
                fontWeight: 400,
                textAlign: "center",
                cursor: "pointer",
                padding: isMobile ? "13px 0px 18.5px 0px" : "18px 0px 19px 0px",
              }}
            >
              닫기
            </LSRgH2HeadLine>
          </div>
        </div>
      </ModalContain>
    </ModalWrapper>
  );
};

export default PopupModal;

// 페이드인 효과 정의
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const ModalWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 70px 0; */
  padding: ${(props) => (props.$isMobile ? "0px 20px" : "70px 0px")};
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 1000;

  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(2px);

  overflow: hidden;
  touch-action: none;
`;

const ModalContain = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isMobile ? "335px" : "450px")};
  padding: 0px;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 8px 8px 35px 0px #00000073;

  animation: ${fadeIn} 0.7s ease-out;
`;
